import { render, staticRenderFns } from "./Heardes.vue?vue&type=template&id=55af8bc8&scoped=true"
import script from "./Heardes.vue?vue&type=script&lang=js"
export * from "./Heardes.vue?vue&type=script&lang=js"
import style0 from "./Heardes.vue?vue&type=style&index=0&id=55af8bc8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55af8bc8",
  null
  
)

export default component.exports